export let accessTokenProvider: () => Promise<string> | undefined;

export const setAccessTokenProvider = (provider: () => Promise<string>) => {
  accessTokenProvider = provider;
};
